// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Theme fallbacks */
/* Gold accents (solid, no gradients) */
/* Add left/right padding around the component */
.cd {
  font-family: "Almendra", serif;
  padding-left: 1rem;
  padding-right: 1rem;
}
@media (min-width: 1024px) {
  .cd {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}

/* Pure white shell with SOLID gold border (no gradient) */
.cd__shell {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-radius: 11px;
  background: #ffffff; /* no inner gradient */
  border: 2px solid #d4af37; /* solid gold edge */
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

/* Each unit */
.cd__unit {
  text-align: center;
  padding: 0.9rem 0.6rem;
  position: relative;
  /* subtle SOLID divider between units (no gradient) */
}
.cd__unit + .cd__unit::before {
  content: "";
  position: absolute;
  left: 0;
  top: 12%;
  bottom: 12%;
  width: 1px;
  background-color: rgba(212, 175, 55, 0.45);
}

.cd__num {
  font-size: clamp(2rem, 6vw, 3rem);
  line-height: 1.1;
  color: #0b0b0c;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.cd__label {
  margin-top: 0.15rem;
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6b7280;
}

/* Compact tweak for small screens */
@media (max-width: 520px) {
  .cd__num {
    font-size: clamp(1.8rem, 8vw, 2.6rem);
  }
  .cd__label {
    font-size: 0.9rem;
  }
  .cd__unit {
    padding: 0.75rem 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/CountDownComponent/CountDownComponent.scss"],"names":[],"mappings":"AAEA,oBAAA;AAKA,uCAAA;AAMA,gDAAA;AACA;EACE,8BAAA;EACA,kBAAA;EACA,mBAAA;AAVF;AAYE;EALF;IAMI,qBAAA;IACA,sBAAA;EATF;AACF;;AAYA,0DAAA;AACA;EACE,aAAA;EACA,qCAAA;EACA,mBAlBO;EAmBP,mBAAA,EAAA,sBAAA;EACA,yBAAA,EAAA,oBAAA;EACA,0CAAA;EACA,gBAAA;AATF;;AAYA,cAAA;AACA;EACE,kBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,qDAAA;AAVF;AAWE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EAAS,QAAA;EAAU,WAAA;EACnB,UAAA;EACA,0CAAA;AAPJ;;AAWA;EACE,iCAAA;EACA,gBAAA;EACA,cAnDQ;EAoDR,gBAAA;EACA,qBAAA;AARF;;AAWA;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cA5DQ;AAoDV;;AAWA,oCAAA;AACA;EACE;IAAa,qCAAA;EAPb;EAQA;IAAa,iBAAA;EALb;EAMA;IAAa,uBAAA;EAHb;AACF","sourcesContent":["@use \"../styles/tokens\" as *;\r\n\r\n/* Theme fallbacks */\r\n$primary: if(global-variable-exists(color-primary), $color-primary, #7c3aed);\r\n$text:    if(global-variable-exists(color-text),   $color-text,   #0b0b0c);\r\n$muted:   if(global-variable-exists(color-muted),  $color-muted,  #6b7280);\r\n\r\n/* Gold accents (solid, no gradients) */\r\n$gold-1: #d4af37;\r\n$gold-2: #f0e1a1;\r\n\r\n$radius: if(global-variable-exists(btn-radius), $btn-radius, 16px);\r\n\r\n/* Add left/right padding around the component */\r\n.cd {\r\n  font-family: 'Almendra', serif;\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n\r\n  @media (min-width: 1024px) {\r\n    padding-left: 1.25rem;\r\n    padding-right: 1.25rem;\r\n  }\r\n}\r\n\r\n/* Pure white shell with SOLID gold border (no gradient) */\r\n.cd__shell {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  border-radius: $radius;\r\n  background: #ffffff;                 /* no inner gradient */\r\n  border: 2px solid $gold-1;           /* solid gold edge */\r\n  box-shadow: 0 8px 24px rgba(0,0,0,.06);\r\n  overflow: hidden;\r\n}\r\n\r\n/* Each unit */\r\n.cd__unit {\r\n  text-align: center;\r\n  padding: .9rem .6rem;\r\n  position: relative;\r\n\r\n  /* subtle SOLID divider between units (no gradient) */\r\n  & + &::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0; top: 12%; bottom: 12%;\r\n    width: 1px;\r\n    background-color: rgba($gold-1, .45);\r\n  }\r\n}\r\n\r\n.cd__num {\r\n  font-size: clamp(2rem, 6vw, 3rem);\r\n  line-height: 1.1;\r\n  color: $text;\r\n  font-weight: 700;\r\n  letter-spacing: .5px;\r\n}\r\n\r\n.cd__label {\r\n  margin-top: .15rem;\r\n  font-size: .95rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: .08em;\r\n  color: $muted;\r\n}\r\n\r\n/* Compact tweak for small screens */\r\n@media (max-width: 520px) {\r\n  .cd__num   { font-size: clamp(1.8rem, 8vw, 2.6rem); }\r\n  .cd__label { font-size: .9rem; }\r\n  .cd__unit  { padding: .75rem .5rem; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
